import { render, staticRenderFns } from "./block.vue?vue&type=template&id=7c77c70b&scoped=true&"
import script from "./block.vue?vue&type=script&lang=js&"
export * from "./block.vue?vue&type=script&lang=js&"
import style0 from "./block.vue?vue&type=style&index=0&id=7c77c70b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c77c70b",
  null
  
)

export default component.exports